<app-header></app-header>
<app-page-title></app-page-title>


<div class="container-fluid">
  <div class="row gx-3">
    <!-- Region Filter -->
    <div class="col-lg-3">
      <select [(ngModel)]="regionFilter" class="form-select w-100">
        <option value="">Select Region</option>
        <option *ngFor="let regionRow of regionList" [value]="regionRow.region_name">
          {{ regionRow.region_name }}
        </option>
      </select>
    </div>

    <!-- Start Date and Time -->
    <div class="col-lg-3">
      <input autocomplete="off" pattern="^[^<>]*$" type="text"
             placeholder="Start Date"
             class="form-control mb-1"
             #dp="bsDatepicker"
             bsDatepicker
             [bsValue]="startReportDate"
             [maxDate]="maxStartDate"
             (bsValueChange)="onStartDateChange($event)">
      <timepicker class="d-block" [showMeridian]="false" [(ngModel)]="startReportTime"></timepicker>
    </div>

    <!-- End Date and Time -->
    <div class="col-lg-3">
      <input autocomplete="off" pattern="^[^<>]*$" type="text"
             placeholder="End Date"
             class="form-control mb-1"
             #dp="bsDatepicker"
             bsDatepicker
             [bsValue]="endReportDate"
             [maxDate]="maxEndDate"
             (bsValueChange)="onEndDateChange($event)">
      <timepicker class="d-block" [showMeridian]="false" [(ngModel)]="endReportTime"></timepicker>
    </div>

    <!-- Search Button -->
    <div class="col-lg-3 d-flex align-items-start">
      <button class="btn btn-primary w-100" (click)="getCloseIndustry()">
        <i class="icon icon-search4"></i> Search
      </button>
    </div>
  </div>
</div>


<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div *ngIf="firstLevel" class="card shadow-sm">
        <div class="card-header bg-white">
          <h5 class="card-title mb-0">
            Monitoring Report of Device Close Status
          </h5>
        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table *ngIf="!regionLoader" class="table table-hover">
              <thead class="table-light">
              <tr>
                <th>Region Name</th>
                <th>Name of Officer</th>
                <th>District</th>
                <th class="text-center">Total No of Industries</th>
                <th class="text-center">No of Industries Offline</th>
              </tr>
              </thead>

              <tbody>
              <ng-container *ngFor="let regionDetail of firstLevel | keyvalue">
                <tr *ngFor="let region of regionDetail.value | keyvalue">
                  <td>{{region.key}}</td>
                  <td>{{region.value.name}}</td>
                  <td>{{region.value.city}}</td>
                  <td class="text-center">{{region.value.industry_count}}</td>
                  <td class="text-center">
                    <a *ngIf="region.value.total_close"
                       (click)="getCloseIndustryList(region.key,region.value.name)"
                       data-bs-toggle="modal"
                       data-bs-target="#secondLevel"
                       class="text-decoration-none">
                      {{region.value.total_close}}
                    </a>
                    <span *ngIf="!region.value.total_close" class="text-muted">
                        {{region.value.total_close}}
                      </span>
                  </td>
                </tr>
              </ng-container>
              </tbody>
            </table>
          </div>

          <div *ngIf="regionLoader" class="text-center py-5">
            <img src="/assets/images/load.gif" alt="Loading..." />
          </div>
        </div>
      </div>

      <div *ngIf="!firstLevel" class="text-center py-5">
        <h4 class="text-danger fw-bold">No Close Industry Report Found</h4>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->

<div class="modal fade" id="secondLevel" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" *ngIf="!moreDetailDrilled">
          {{selectedOfficerName}} | {{selectedRegionName}}
        </h5>
        <h5 class="modal-title" *ngIf="moreDetailDrilled">
          {{selectedIndustryName}} | {{selectedIndustryAddress}}
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <div *ngIf="!moreDetailDrilled">
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
              <tr>
                <th>Name of Industry</th>
                <th>Address of Industry</th>
                <th>District</th>
                <th>Average Close Time</th>
                <th>No of Interval of Close/Non-Operation CEMS</th>
                <th>Name of Parameter Displayed by Industry</th>
                <th>Detail Status</th>
              </tr>
              </thead>
              <tbody *ngIf="!industryLoader">
              <tr *ngFor="let industry of closeIndustryList | keyvalue">
                <td>{{industry.value.name}}</td>
                <td>{{industry.value.address}}</td>
                <td>{{industry.value.city}}</td>
                <td>{{industry.value.average_time}} Hours</td>
                <td>{{industry.value.total_interval}} Times</td>
                <td>
                  {{industryParameterList[industry.key]['parameter']}}
                </td>
                <td>
                  <button (click)="getIndustryCloseTimeWise(industry.value.name,industry.value.address,industry.value.id)"
                          class="btn btn-sm btn-primary">
                    <i class="fas fa-ellipsis-h"></i>
                  </button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="industryLoader" class="text-center py-5">
            <img src="/assets/images/load.gif" alt="Loading..." />
          </div>
        </div>

        <div *ngIf="moreDetailDrilled">
          <button (click)="backToPreviousLevel()" class="btn btn-sm btn-primary mb-3">
            <i class="fas fa-arrow-left me-1"></i> Back
          </button>
          <div class="table-responsive">
            <table class="table table-hover">
              <thead class="table-light">
              <tr>
                <th class="text-center">SNo.</th>
                <th class="text-center">Close From</th>
                <th class="text-center">Close Till</th>
              </tr>
              </thead>
              <tbody *ngIf="!historyLoader">
              <tr *ngFor="let history of closeIndustryHistory | keyvalue; let i = index">
                <td class="text-center">{{i + 1}}</td>
                <td class="text-center">
                  {{history.value.from_date_time | date: 'dd MMM yyyy HH:mm'}}
                </td>
                <td class="text-center">
                    <span *ngIf="history.value.to_date_time">
                      {{history.value.to_date_time | date: 'dd MMM yyyy HH:mm'}}
                    </span>
                  <span *ngIf="!history.value.to_date_time" class="text-muted">
                      Till Now
                    </span>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div *ngIf="historyLoader" class="text-center py-5">
            <img src="/assets/images/load.gif" alt="Loading..." />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
